export default function ValidatePostalCode(PostalCode) {
  var valid = true;

  var rfvPostalCode = PostalCode.siblings("#PostalCodeRequired");
  var revPostalCode = PostalCode.siblings("#PostalCodeRegex");

  rfvPostalCode.hide();
  revPostalCode.hide();
  PostalCode.removeClass("error");
  if ($.trim(PostalCode.val()).length == 0) {
    valid = false;
    rfvPostalCode.show();
    PostalCode.addClass("error");
  }
  else if ($("#catalogReg").length > 0) {
    var regExpZip = /^(\d\d\d \d\d|\d\d\d\d\d|\d\d\d\d)$/;
    if (!regExpZip.test(PostalCode.val())) {
      valid = false;
      revPostalCode.show();
      PostalCode.addClass("error");
    }
  }
  else {
    var regExpZip = /^[1-9]{1}[0-9]{4}$/gm;
    if (!regExpZip.test(PostalCode.val())) {
      valid = false;
      revPostalCode.show();
      PostalCode.addClass("error");
    }
  }
  return valid;
}